import { createFileRoute } from '@tanstack/react-router';
import { BatchHub } from '@/features/Course/BatchHub';

export const Route = createFileRoute('/_student/courses/$batchId/')({
  component: BatchHubRoute,
});

function BatchHubRoute() {
  const { batchId } = Route.useParams();
  return <BatchHub batchId={batchId} />;
}
